/**
 * Public vacation-package booking confirmation / access routes.
 * Order ref in the URL is the real HR-######## (or technical id only as fallback).
 */
import { appendPublicSiteToken } from "../../utils/publicSiteUrl";

export const PUBLIC_BOOKING_CONFIRMATION_BASE = "/booking/confirmation";
export const PUBLIC_BOOKING_ACCESS_PATH = "/booking/access";
export const PUBLIC_BOOKING_VIEW_BASE = "/booking/view";

export function encodePublicBookingRef(orderRef) {
  const raw = String(orderRef || "").trim();
  if (!raw) return "";
  return encodeURIComponent(raw);
}

export function getPublicBookingConfirmationPath(orderRef) {
  const enc = encodePublicBookingRef(orderRef);
  if (!enc) return PUBLIC_BOOKING_CONFIRMATION_BASE;
  return `${PUBLIC_BOOKING_CONFIRMATION_BASE}/${enc}`;
}

export function getPublicBookingAccessPath(orderRef = "") {
  const ref = String(orderRef || "").trim();
  if (!ref) return PUBLIC_BOOKING_ACCESS_PATH;
  const q = new URLSearchParams({ ref });
  return `${PUBLIC_BOOKING_ACCESS_PATH}?${q.toString()}`;
}

export function getPublicBookingViewPath(orderRef) {
  const enc = encodePublicBookingRef(orderRef);
  if (!enc) return PUBLIC_BOOKING_ACCESS_PATH;
  return `${PUBLIC_BOOKING_VIEW_BASE}/${enc}`;
}

export function publicBookingHref(path) {
  return appendPublicSiteToken(path);
}

export function normalizePublicHrRef(raw) {
  const s = String(raw || "").trim().replace(/[\u200e\u200f]/g, "");
  const withoutPrefix = s.replace(/^hr[\s\-_:]*/i, "");
  const digits = withoutPrefix.replace(/\D/g, "");
  if (digits.length === 8 && digits[0] !== "0") return digits;
  return "";
}

export function publicHrRefsMatch(a, b) {
  const left = normalizePublicHrRef(a);
  const right = normalizePublicHrRef(b);
  return Boolean(left) && left === right;
}

export function isPublicBookingRoute(pathname) {
  const path = String(pathname || "").replace(/\/+$/, "") || "/";
  return (
    path === "/booking" ||
    path.startsWith("/booking/")
  );
}
